module.exports = require('./lib/heap');



//////////////////
// WEBPACK FOOTER
// ./~/heap/index.js
// module id = 66
// module chunks = 0